export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/course-training`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        updateMaterials: {
            method: 'POST',
            url: `${url}/update-materials`,
            isArray: false
        },
        translateMaterial: {
            method: 'POST',
            url: `${url}/translate-material`,
            isArray: false
        },
        confirmMaterialTranslation: {
            method: 'POST',
            url: `${url}/confirm-material-translation`,
            isArray: false
        },
        changeMaterialLanguageVisibility: {
            method: 'POST',
            url: `${url}/change-material-language-visibility`,
            isArray: false
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/CourseTraining/index.js